class Request1 {
  constructor() {
    this.consent = document.querySelector(".js-form1Consent");
    this.consentButton = document.querySelector(".js-form1ConsentButton");

    this.initialize();
  }

  initialize() {
    if( this.consent ) {
      this.consent1();
    }
  }

  consent1() {
    this.consent.addEventListener("change", (e) => {
      if( e.currentTarget.checked ) {
        this.consentButton.disabled = false;
      } else {
        this.consentButton.disabled = true;
      }
    });

  }
}

export default Request1;